import { Outlet } from "react-router-dom";

export default function ShopOutline() {
  return <Outlet />;
}
